const submissionSelectors = {
    collapsedGroupIds: state => state.group.collapsedGroupIds,
    isGroupCollapsed: id => state => state.group.collapsedGroupIds.includes(id),
    isGloballyCollapsed: state => state.group.globallyCollapsed,
}

export default submissionSelectors
